<template>
  <div>
    <div>
      <Button type="primary" icon="ios-search" @click="showSearch">搜索</Button>

      <Button style="margin-left: 20px" type="primary" icon="md-cloud-upload" @click="dialogVisible = true">导出
      </Button>
    </div>

    <div>
      <Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <span>搜索</span>
        </p>
        <div style="padding-left: 20px;">
          <CheckboxGroup v-model="selectedConditions" class="check_group">
            <div>
              <Checkbox label="num">
                <span>设备编号</span>
              </Checkbox>
              <Input v-model="condition.num" placeholder=""/>
            </div>
            <div>
              <Checkbox label="type">
                <span>通讯类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="condition.type">
                <Option :value="1" :key="1">NB</Option>
                <Option :value="2" :key="2">WIFI</Option>
              </Select>

            </div>
            <div>
              <Checkbox label="gasType">
                <span>用气类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="condition.gasType">
                <Option :value="1" :key="1">液化天然气</Option>
                <Option :value="2" :key="2">液化石油气</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="subType">
                <span>类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="condition.subType">
                <Option :value="1" :key="F02">感测泄露</Option>
                <Option :value="2" :key="F12">甲烷传感器泄露</Option>
                <Option :value="3" :key="F13">甲烷传感器过期</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="happenTime">
                <span>时间范围</span>
              </Checkbox>
              <Tooltip transfer placement="top" :disabled="condition.happenTimeRange[0] == ''">
                <div slot="content">
                  <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', condition.happenTimeRange[0]) }}</span>
                  <br/>
                  <span style="margin-left:50%">~</span>
                  <br/>
                  <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', condition.happenTimeRange[1]) }}</span>
                </div>
                <DatePicker v-model="condition.happenTimeRange" type="daterange" split-panels
                            placeholder=""></DatePicker>
              </Tooltip>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
        </div>
      </Modal>

      <Modal title="Title" v-model="dialogVisible" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <span>导出</span>
        </p>
        <div style="padding-left: 20px;">
          <CheckboxGroup v-model="expSelectedConditions" class="check_group">
            <div>
              <Checkbox label="num">
                <span>设备编号</span>
              </Checkbox>
              <Input v-model="expCondition.num" placeholder=""/>
            </div>
            <div>
              <Checkbox label="type">
                <span>通讯类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="expCondition.type">
                <Option :value="1" :key="1">NB</Option>
                <Option :value="2" :key="2">WIFI</Option>
              </Select>

            </div>
            <div>
              <Checkbox label="gasType">
                <span>用气类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="expCondition.gasType">
                <Option :value="1" :key="1">液化天然气</Option>
                <Option :value="2" :key="2">液化石油气</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="subType">
                <span>类型</span>
              </Checkbox>
              <Select :readonly="showType=='show'" v-model="expCondition.subType">
                <Option :value="1" :key="F02">感测泄露</Option>
                <Option :value="2" :key="F12">甲烷传感器泄露</Option>
                <Option :value="3" :key="F13">甲烷传感器过期</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="happenTime">
                <span>时间范围</span>
              </Checkbox>
              <Tooltip transfer placement="top" :disabled="expCondition.happenTimeRange[0] == ''">
                <div slot="content">
                  <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', expCondition.happenTimeRange[0]) }}</span>
                  <br/>
                  <span style="margin-left:50%">~</span>
                  <br/>
                  <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', expCondition.happenTimeRange[1]) }}</span>
                </div>
                <DatePicker v-model="expCondition.happenTimeRange" type="daterange" split-panels
                            placeholder=""></DatePicker>
              </Tooltip>
            </div>
            <div>
              <Checkbox label="pageSize">
                <span>导出条数</span>
              </Checkbox>
              <InputNumber :precision="0" v-model="expCondition.pageSize" placeholder="默认仅导出50条"/>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button type="info" size="large" long @click="exportExcel">立即导出</Button>
        </div>
      </Modal>
    </div>
    <br/>

    <Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
      </template>
    </Table>
    <br/>

    <Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
          show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize"/>
  </div>
</template>

<script>
import {
  constants
} from "crypto";
import * as XLSX from "xlsx";
import {saveAs} from 'file-saver';
export default {
  name: "alarm_Record",
  data() {
    let that = this;
    return {
      boxProfile: {},
      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: '',
      selectData: {},
      searchModal: false,
      dialogVisible: false,
      currentPage: 1,
      pageSize: 40,
      totalRows: 0,
      selectedConditions: [],
      expSelectedConditions: [],
      condition: {
        id: '',
        mac: '',
        happenTimeRange: [],
      },
      expCondition: {
        id: '',
        mac: '',
        happenTimeRange: [],
        pageSize: ''
      },
      requestBody: {},
      columns1: [{
        title: "姓名",
        key: "name",
        align: "center",
        width: 100,
      },
        {
          title: "电话",
          key: "telephone",
          align: "center",
          width: 200,
        },
        {
          title: "地址",
          key: "address",
          align: "center",
          width: 200,
        },
        {
          title: "设备编号",
          key: "num",
          align: "center",
          width: 200,
        },
        {
          title: "类型",
          align: "center",
          render: function (h, params) {
            if (params.row.subType == "F02") {
              return h(
                  "div",
                  '泄漏报警'
              )
            } else if (params.row.subType == 'F12') {
              return h(
                  "div",
                  '传感器检测失效'
              )
            } else if (params.row.subType == "F13") {
              return h(
                  "div",
                  '传感器寿命失效'
              )
            }
          }
        },
        {
          title: "报警类型",
          key: "",
          align: "center",
          width: 300,
          render: function (h, params) {
            if (params.row.mainType == 'errorTrig' && params.row.subType == "F02") {
              return h(
                  "div",
                  '触发时AD值：' + JSON.parse(params.row.content).adValue / 1000 + ' V'
              )
            } else if (params.row.mainType == 'errorClear' && params.row.subType == 'F02') {
              return h(
                  "div",
                  '用户已解除 解除时AD值：' + JSON.parse(params.row.content).adValue / 1000 + ' V'
              )
            } else if (params.row.mainType == 'errorTrig' && params.row.subType == "F12") {
              return h(
                  "div",
                  '触发时AD值：' + JSON.parse(params.row.content).adValue / 1000 + ' V'
              )
            } else if (params.row.mainType == 'errorClear' && params.row.subType == 'F12') {
              return h(
                  "div",
                  '用户已解除'
              )
            } else if (params.row.mainType == 'errorTrig' && params.row.subType == "F13") {
              return h(
                  "div",
                  '触发时AD值：' + JSON.parse(params.row.content).adValue / 1000 + ' V'
              )
            } else if (params.row.mainType == 'errorClear' && params.row.subType == 'F13') {
              return h(
                  "div",
                  '用户已解除'
              )
            }
          }
        },
        {
          title: "上传时间",
          align: "center",
          width: 200,
          render: function (h, params) {
            try {
              if (params.row.happenTime != undefined) {
                let timeStr = global.dateFtt(
                    "yyyy-MM-dd hh:mm:ss",
                    new Date(params.row.happenTime)
                );
                return h("div", timeStr == "" ? "设备未校时" : timeStr);
              } else {
                return h(
                    "div",
                    global.dateFtt(
                        "yyyy-MM-dd hh:mm:ss",
                        new Date(params.row.receiveTime)
                    )
                );
              }
            } catch (err) {
              return h("div", "JSON格式错误");
            }
          }
        },
        {
          title: "用气类型",
          key: "",
          align: "center",
          width: 150,
          render: function (h, params) {
            return h(
                "div",
                params.row.gasType == 1 ? "液化天然气" : "液化石油气"
            );
          }
        },
        {
          title: "通讯方式",
          key: "",
          align: "center",
          width: 100,
          render: function (h, params) {
            return h(
                "div",
                params.row.type == 1 ? "NB" : "WIFI"
            );
          }
        },
      ],
    };
  },
  created() {

    this.getMessage()
  },
  mounted() {

  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    // 显示条件检索页面
    showSearch() {
      this.searchModal = true;
    },
    searchByCondition() {
      this.requestBody = {};
      for (let i in this.selectedConditions) {
        let selectedCondition = this.selectedConditions[i]
        switch (selectedCondition) {
          case 'happenTime':
            let happenTimeBegin = this.condition.happenTimeRange[0];
            if (happenTimeBegin != '') {
              this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
                  happenTimeBegin);
            }
            let happenTimeEnd = this.condition.happenTimeRange[1];
            if (happenTimeEnd != '') {
              this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
            }
            if (this.id != "") {
              this.requestBody["id"] = this.id;
            }
            if (this.num != "") {
              this.requestBody["num"] = this.num;
            }
            if (this.type.value != "") {
              this.requestBody["type"] = this.type;
            }
            if (this.gasType.value != "") {
              this.requestBody["gasType"] = this.gasType;
            }
            if (this.subType.value != "") {
              this.requestBody["subType"] = this.subType;
            }
            break;
          default:
            let value = this.condition[selectedCondition];
            if (value == null || value == '') {
              break;
            }

            this.requestBody[selectedCondition] = value;
            break;
        }
      }

      this.loading = true;
      this.searchModal = false;
      this.currentPage = 1;
      this.getMessage();
    },
    exportExcel() {
      let requestBody = {};
      for (let i in this.expSelectedConditions) {
        let selectedCondition = this.expSelectedConditions[i]
        switch (selectedCondition) {
          case 'happenTime':
            let happenTimeBegin = this.expCondition.happenTimeRange[0];
            if (happenTimeBegin != '') {
              requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
                  happenTimeBegin);
            }
            let happenTimeEnd = this.expCondition.happenTimeRange[1];
            if (happenTimeEnd != '') {
              requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
            }
            if (this.id != "") {
              requestBody["id"] = this.id;
            }
            if (this.num != "") {
              requestBody["num"] = this.num;
            }
            if (this.type.value != "") {
              requestBody["type"] = this.type;
            }
            if (this.gasType.value != "") {
              requestBody["gasType"] = this.gasType;
            }
            if (this.subType.value != "") {
              requestBody["subType"] = this.subType;
            }
            break;
          default:
            let value = this.expCondition[selectedCondition];
            if (value == null || value === '') {
              break;
            }
            requestBody[selectedCondition] = value;
            break;
        }
      }

      let that = this;
      if (localStorage.getItem("isAdmin") !== "true") {
        requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
      }

      if (!requestBody["pageSize"]) {
        requestBody["pageSize"] = 50;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在导出，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      $.ajax({
        url: "/api/alarm/admin/message/getAlarmErrorList?currentPage=" + 1 +
            "&pageSize=" +
            requestBody["pageSize"] +
            "&paging=true&",
        type: "post",
        data: that.requestBody,
        success: function (result) {
          if (!result.success) {
            that.$Notice.error({
              title: "异常",
              desc: result.msg
            });
            loading.close();
            return;
          }

          const data = [
            [
              "姓名",
              "电话",
              "地址",
              "设备编号",
              "类型",
              "报警类型",
              "上传时间",
              "用气类型",
              "通讯方式"
            ]
          ]

          result.data.list.forEach(item => {
            let alarmType = ""
            if (item.mainType === 'errorTrig' && item.subType === "F02") {
              alarmType = '触发时AD值：' + JSON.parse(item.content).adValue / 1000 + ' V'
            } else if (item.mainType === 'errorClear' && item.subType === 'F02') {
              alarmType = '用户已解除 解除时AD值：' + JSON.parse(item.content).adValue / 1000 + ' V'
            } else if (item.mainType === 'errorTrig' && item.subType === "F12") {
              alarmType = '触发时AD值：' + JSON.parse(item.content).adValue / 1000 + ' V'
            } else if (item.mainType === 'errorClear' && item.subType === 'F12') {
              alarmType = '用户已解除'
            } else if (item.mainType === 'errorTrig' && item.subType === "F13") {
              alarmType = '触发时AD值：' + JSON.parse(item.content).adValue / 1000 + ' V'
            } else if (item.mainType === 'errorClear' && item.subType === 'F13') {
              alarmType = '用户已解除'
            }

            let uploadTime = "";
            if (item.happenTime != null) {
              let timeStr = global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(item.happenTime)
              );
              uploadTime = timeStr === "" ? "设备未校时" : timeStr
            } else {
              uploadTime = global.dateFtt(
                      "yyyy-MM-dd hh:mm:ss",
                      new Date(item.receiveTime)
                  )
            }

            const list = [
              item.name ? item.name : "",
              item.telephone ? item.telephone : "",
              item.address ? item.address : "",
              item.num ? item.num : "",
              item.subType === "F02" ? "泄漏报警" : item.subType === "F12" ? "传感器检测失效" : item.subType === "F13" ? "传感器寿命失效" : "",
              alarmType,
              uploadTime,
              item.gasType === 1 ? "液化天然气" : "液化石油气",
              item.type === 1 ? "NB" : "WIFI"
            ]

            data.push(list)
          })

          // 将数据转换为工作表
          const worksheet = XLSX.utils.aoa_to_sheet(data);
          // 创建工作簿并添加工作表
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          // 生成Excel文件
          const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

          // 使用blob和FileReader创建一个URL然后下载
          const dataBlob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
          saveAs(dataBlob, '报警器记录.xlsx');

          loading.close();
        },
        error: function (textStatus) {
          loading.close();
          that.$Notice.error({
            title: "异常",
            desc: "网络不通"
          });
        }
      });
    },
    getMessage() {
      let that = this;
      if (localStorage.getItem("isAdmin") != "true") {
        that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
      }
      $.ajax({
        url: "/api/alarm/admin/message/getAlarmErrorList?currentPage=" + that.currentPage +
            "&pageSize=" +
            that.pageSize +
            "&paging=true&",
        type: "post",
        data: that.requestBody,
        success: function (result) {
          if (!result.success) {
            that.$Notice.error({
              title: "异常",
              desc: result.msg
            });
            return;
          }
          that.data1 = result.data.list;
          that.totalRows = result.data.totalRows;
          that.loading = false;
        },
        error: function (textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "网络不通"
          });
        }
      });
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
    },
    changePage(index) {
      this.currentPage = index;
      this.loading = true;
      this.getMessage();
    },
    convertData(data, type, enums) {
      let result = data;
      if (type == "Time") {
        result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
      } else if (type == "Enum") {
        result = enums[data] == null ? data : enums[data];
      }
      return result;
    },
  },
};
</script>

<style>
.check_group > div {
  margin-bottom: 10px;
}

.check_group > div > label {
  width: 100px;
}

.check_group > div > div {
  width: 200px;
}

.ivu-date-picker {
  width: 100%;
}
</style>
